var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUncategorized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4706 12.8247H1.42505V34.1971H38.4706V12.8247Z",
    fill: "#FB8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9713 4.6899C28.4198 4.48152 27.798 4.76209 27.5896 5.31368L27.2723 6.15333L17.044 2.28809L10.5386 19.5053L31.4951 28.4404L32.3926 27.7629L38.4131 11.8307L38.8987 10.5463L39.216 9.70668C39.4244 9.15509 39.1438 8.53335 38.5922 8.32497L28.9713 4.6899Z",
    fill: "#37474F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9386 1.80053e-05L15.7808 9.14587L29.1688 18.16L35.3267 9.01416L21.9386 1.80053e-05Z",
    fill: "#D3F4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M13.1574 11.826C13.0866 11.9534 13.1322 12.1134 13.2595 12.1842L29.7072 21.3441C29.8346 21.4149 29.9946 21.3693 30.0654 21.2419C30.0654 21.2419 35.5432 9.45756 35.4159 9.38674L19.7465 0.535364C19.6199 0.464542 13.1574 11.826 13.1574 11.826Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8781 0.487025L12.3916 12.136L29.3001 21.5511L35.7866 9.90215L18.8781 0.487025Z",
    fill: "#BCEDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M29.7734 20.9744L34.4299 8.93194L17.259 1.67065L12.3076 14.0502L29.7734 20.9744Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0649 1.7211L11.113 14.1007L29.0821 21.2883L34.0339 8.90872L16.0649 1.7211Z",
    fill: "#E6FFFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M28.5551 5.10665C28.0035 4.89827 27.3818 5.17883 27.1734 5.73043L26.856 6.57008L16.6277 2.70483L10.1223 19.9214L31.4949 28.4404L37.9969 12.2474L38.4824 10.9631L38.7997 10.1234C39.0081 9.57184 38.7276 8.9501 38.176 8.74172L28.5551 5.10665Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0739 5.36842C27.5223 5.16004 26.9006 5.4406 26.6922 5.9922L26.3748 6.83185L16.1465 2.96729L9.64111 20.1838L31.4951 28.4421L37.5157 12.5099L38.0012 11.2255L38.3185 10.3859C38.5269 9.83429 38.2464 9.21255 37.6948 9.00417L28.0739 5.36842Z",
    fill: "#546E7A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1638 10.2361L37.2906 12.5515L38.1582 10.96L31.4716 8.43359L31.1638 10.2361Z",
    fill: "#FFD092"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0298 10.2822L32.9592 10.4689L37.064 12.0201L37.1345 11.8335L33.0298 10.2822Z",
    fill: "#A67C52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3594 9.56776L32.2888 9.75439L37.2178 11.6171L37.2884 11.4305L32.3594 9.56776Z",
    fill: "#A67C52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4758 9.25904L32.4053 9.44568L37.3343 11.3084L37.4048 11.1218L32.4758 9.25904Z",
    fill: "#A67C52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M31.8762 8.58363L38.1501 10.9698L31.9879 8.28809L31.8762 8.58363Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1467 10.364L37.0228 10.4628C36.9166 10.5472 36.8988 10.7025 36.9833 10.8087L37.8304 11.8731C37.9149 11.9793 38.0701 11.997 38.1764 11.9126L38.3003 11.8138C38.4065 11.7294 38.4242 11.5741 38.3398 11.4679L37.4927 10.4035C37.4082 10.2966 37.253 10.2789 37.1467 10.364ZM37.4035 10.4737L38.2506 11.538C38.2962 11.5953 38.2867 11.6783 38.2295 11.724L38.1055 11.8227C38.0483 11.8683 37.9653 11.8588 37.9196 11.8016L37.0725 10.7372C37.0269 10.68 37.0364 10.5969 37.0936 10.5513L37.2175 10.4526C37.2747 10.4076 37.3578 10.4172 37.4035 10.4737Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9048 9.90882L36.7427 10.0382C36.6167 10.1383 36.5827 10.3052 36.6658 10.41L37.4836 11.4369L37.5728 11.3661L36.755 10.3392C36.7114 10.2847 36.7379 10.1873 36.8135 10.1274L36.9756 9.99803C37.0512 9.9381 37.1513 9.93334 37.1949 9.9885L38.0127 11.0154L38.1019 10.9446L37.2841 9.91768C37.201 9.81212 37.0308 9.80872 36.9048 9.90882Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M31.4951 28.4421L16.1465 2.96729L9.64111 20.1838L31.4951 28.4421Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M28.7244 10.1995L19.8372 13.8035L21.6831 18.3553L30.5703 14.7513L28.7244 10.1995Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3909 10.0343L19.5037 13.6383L21.3496 18.1902L30.2368 14.5862L28.3909 10.0343Z",
    fill: "#FBEE31"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M19.5037 13.6432L24.9985 14.4331L28.3911 10.0394L24.8698 14.1171L19.5037 13.6432Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M24.8698 14.1171L28.3911 10.0394L19.5037 13.6432L24.8698 14.1171Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9679 4.14414L0.76416 10.4637L9.35078 25.6865L20.5545 19.3669L11.9679 4.14414Z",
    fill: "#78909C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M12.719 2.52136L1.23755 9.06348L10.2557 24.8904L21.7371 18.3482L12.719 2.52136Z",
    fill: "#241349"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3066 2.40893L0.825195 8.95105L9.84337 24.7779L21.3248 18.2358L12.3066 2.40893Z",
    fill: "#CFFFF6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M13.3888 1.79056L1.50439 7.56628L9.46611 23.9487L21.3505 18.173L13.3888 1.79056Z",
    fill: "#241349"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9848 1.65152L1.10034 7.42725L9.06205 23.8097L20.9465 18.034L12.9848 1.65152Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2746 3.91786L4.15503 7.86389L4.35684 8.27915L12.4764 4.33312L12.2746 3.91786Z",
    fill: "#BEBEBE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6802 4.75382L3.75342 9.09216L3.95523 9.50742L12.882 5.16908L12.6802 4.75382Z",
    fill: "#BEBEBE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7206 11.0094L7.60107 14.9554L7.80289 15.3707L15.9224 11.4247L15.7206 11.0094Z",
    fill: "#BEBEBE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1263 11.8454L7.19946 16.1837L7.40127 16.599L16.3281 12.2606L16.1263 11.8454Z",
    fill: "#BEBEBE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6172 6.72917L9.88477 8.54309L10.0866 8.95835L13.819 7.14443L13.6172 6.72917Z",
    fill: "#D9D9D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.03 7.57805L10.2976 9.39197L10.4994 9.80722L14.2318 7.99331L14.03 7.57805Z",
    fill: "#D9D9D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4895 8.52409L10.7571 10.338L10.9589 10.7533L14.6913 8.93935L14.4895 8.52409Z",
    fill: "#D9D9D9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9211 9.41277L11.1887 11.2267L11.3905 11.6419L15.1229 9.82802L14.9211 9.41277Z",
    fill: "#D9D9D9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99133 17.452L7.89868 17.983L9.84744 21.9929L10.9401 21.4619L8.99133 17.452Z",
    fill: "#FBB03B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6285 16.656L9.53589 17.187L11.4846 21.1969L12.5773 20.6659L10.6285 16.656Z",
    fill: "#FBB03B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.317 15.8379L11.2244 16.3689L13.1731 20.3788L14.2658 19.8477L12.317 15.8379Z",
    fill: "#FBB03B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9532 15.0417L12.8606 15.5728L14.8094 19.5826L15.902 19.0516L13.9532 15.0417Z",
    fill: "#FBB03B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6429 14.2215L14.5503 14.7526L16.499 18.7624L17.5917 18.2314L15.6429 14.2215Z",
    fill: "#FBB03B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2806 13.4277L16.188 13.9587L18.1367 17.9686L19.2294 17.4376L17.2806 13.4277Z",
    fill: "#FBB03B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3717 20.29L9.27905 20.821L9.84758 21.9909L10.9402 21.4599L10.3717 20.29Z",
    fill: "#F15A24"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6705 18.8014L10.5779 19.3324L11.4845 21.198L12.5772 20.667L11.6705 18.8014Z",
    fill: "#F15A24"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4879 18.248L12.3953 18.7791L13.1733 20.3801L14.266 19.849L13.4879 18.248Z",
    fill: "#F15A24"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4081 15.9767L13.3154 16.5077L14.81 19.5829L15.9026 19.0519L14.4081 15.9767Z",
    fill: "#F15A24"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3463 15.6658L15.2537 16.1968L16.4997 18.7606L17.5923 18.2296L16.3463 15.6658Z",
    fill: "#F15A24"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5079 13.8929L16.4153 14.424L18.1369 17.9665L19.2296 17.4355L17.5079 13.8929Z",
    fill: "#F15A24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M23.4469 19.9959L10.1896 22.1444L7.79053 6.78628L20.3975 1.73682L23.4469 19.9959Z",
    fill: "#241349"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0226 1.33483L7.30225 3.45898L10.3511 21.7171L23.0715 19.593L20.0226 1.33483Z",
    fill: "#FFE4E4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6479 2.75437L9.95679 4.20569L10.031 4.65032L18.7222 3.199L18.6479 2.75437Z",
    fill: "#BBBBBB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1565 12.6222L11.4653 14.0735L11.5396 14.5181L20.2307 13.0668L20.1565 12.6222Z",
    fill: "#BBBBBB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1565 5.69834L11.4653 7.14966L11.5396 7.59429L20.2307 6.14297L20.1565 5.69834Z",
    fill: "#BBBBBB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2695 13.2996L10.7146 14.8951L10.7888 15.3398L20.3438 13.7442L20.2695 13.2996Z",
    fill: "#B8B8B8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7107 14.5351L13.1963 15.7899L13.2705 16.2345L20.785 14.9797L20.7107 14.5351Z",
    fill: "#C7C7C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8045 15.3752L13.29 16.63L13.3643 17.0746L20.8787 15.8198L20.8045 15.3752Z",
    fill: "#808080"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9627 16.3281L13.4482 17.5829L13.5225 18.0275L21.0369 16.7727L20.9627 16.3281Z",
    fill: "#808080"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1123 17.2237L13.5979 18.4785L13.6721 18.9231L21.1866 17.6683L21.1123 17.2237Z",
    fill: "#808080"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2683 18.1542L13.7539 19.4091L13.8282 19.8537L21.3426 18.5989L21.2683 18.1542Z",
    fill: "#808080"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3692 9.76336L18.4741 10.0793L17.6365 9.48211L17.6794 9.42151L18.4925 10.0017L20.357 9.69049L20.3692 9.76336Z",
    fill: "#666666"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1866 5.84176L9.05542 6.19763L9.09187 6.41592L11.223 6.06004L11.1866 5.84176Z",
    fill: "#BBBBBB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7212 4.50106L17.5901 4.85693L17.6265 5.07522L19.7577 4.71934L19.7212 4.50106Z",
    fill: "#BBBBBB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5223 11.7119L16.3911 12.0677L16.4276 12.286L18.5587 11.9302L18.5223 11.7119Z",
    fill: "#BBBBBB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11.857 11.1583L9.72583 11.5142L9.76228 11.7324L11.8934 11.3766L11.857 11.1583Z",
    fill: "#BBBBBB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6395 15.7473L12.0149 15.8516L12.1192 16.4762L12.7438 16.3719L12.6395 15.7473Z",
    fill: "#ED1C24"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7858 16.6204L12.1611 16.7247L12.2654 17.3494L12.8901 17.2451L12.7858 16.6204Z",
    fill: "#FFAB00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9447 17.5731L12.3201 17.6774L12.4244 18.302L13.049 18.1977L12.9447 17.5731Z",
    fill: "#FFD600"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0939 18.4661L12.4692 18.5704L12.5735 19.1951L13.1982 19.0908L13.0939 18.4661Z",
    fill: "#8CC63F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2499 19.3989L12.6252 19.5032L12.7296 20.1278L13.3542 20.0235L13.2499 19.3989Z",
    fill: "#9575CD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M40.205 15.1047H0V35H40.205V15.1047Z",
    fill: "#E96666"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 15.1047V35L40.205 15.1047H0Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3824 24.2228H18.2375V25.8807H22.3824V24.2228Z",
    fill: "#E0E0E0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M18.2375 24.2228V25.8807L22.3824 24.2228H18.2375Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M22.5591 24.2228L24.4548 27.1242L18.2375 26.1921H22.5591V24.2228Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncategorized);
export default __webpack_public_path__ + "static/media/uncategorized.4cbf14be851e9ea7b9bf46682e243447.svg";
export { ForwardRef as ReactComponent };